<template>
    <div id="modal-editor-delete-image">
        <div class="rp-overlay"></div>
        <div class="rp-modal" style="width: 470px;">
            <div class="rp-modal-header">
                <h3 class="rp-modal-title">{{ $t('Delete image') }}</h3>
                <button class="rp-btn-dismiss" @click="$emit('closeModal')">
                    <XIcon class="w-5 h-5" />
                </button>
            </div>
            <div class="bg-white p-5">
                <div class="mb-4">
                    <div class="flex flex-col gap-1">
                        <div class="text-base font-medium">{{ $t('Are you sure to delete this image') }}?</div>
                        <div v-if="layout.image.id" class="text-sm mt-1">{{ layout.image.name }}</div>
                        <div class="text-xs font-medium mt-2 text-red-600">{{ $t('This action is irreversible') }}</div>
                    </div>
                </div>
                <div class="rp-modal-body-buttons gap-3 mt-4">
                    <button class="rp-btn-secondary" @click="$emit('closeModal')">
                        {{ $t('Cancel') }}
                    </button>
                    <button class="rp-btn-danger" @click="deleteImage()">
                        {{ $t('Delete') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref }       from "vue";
import { helper as $helper }    from "@/utils/helper";

import * as rosepetalModel	    from "rosepetal-model";

let $image = rosepetalModel.default.image;

const $emit = defineEmits(['imageDeleted']);

const props = defineProps({
    image: {
        type: Object,
        required: true,
    }
});

const layout = ref({
    image: { name: '', id: '' },
});

const deleteImage = async () => { 
    if (layout.value.image.id) {
        try {
            await $image.delete(layout.value.image.id);
            $helper.NotificationTxt({ text: "Successfully image deleted", position: "center" });
            $emit('imageDeleted');
        } catch (error) {
            console.error("Error deleting image:", error);
            $helper.NotificationTxt({ text: "Error deleting image", position: "center" });
            return false;
        }
    } else {
        $helper.NotificationTxt({ text: "No image to delete", position: "center" });
        return false;
    }
}

onMounted(() => {
    if (props.image) {
        layout.value.image.id   = props.image.id;
        layout.value.image.name = props.image.name;
    }
});
</script>